<template>
  <div class="content">
    <el-row style="height:38px">
      <el-col :span="24">
        <div
            style="color:#4C9AFF;font-size:14px;display: flex;align-items: center;justify-content: space-between;margin:0px 5px 0px 5px">
          <div @click="goBack" class="exit-btn">
            <img src="../../assets/image/back.png" alt="" style="cursor:pointer;">
            <div>个人档案</div>
          </div>
          <!-- <el-page-header @back="goBack" content="个人档案"></el-page-header> -->
          <!-- <el-button v-if="isPro" type="primary" size="mini" @click="editFormVisible=true">编辑</el-button> -->
          <div></div>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <el-container style="height:calc(100% - 40px);width:100%;position: relative;overflow: auto;">
      <el-main style="height: 100%;padding:0px !important;  position: relative;width: 100%;">
        <el-card style="height:100% !important;" class="aside">
          <!-- 基本情况 -->
          <!-- <div class="table-item h200" style="height: 215px;">
            <div class="item-name">基本信息</div>
            <div class="item-box" style="width: calc( 100% - 460px );">
              <div class="item-box-li50 li33">
                <p class="name">姓名：</p>
                <p class="val">{{info.name}}</p>
              </div>
              <div class="item-box-li50 li33">
                <p class="name">性别：</p>
                <p class="val" v-if="info.sex=='1'">男</p>
                <p class="val" v-else-if="info.sex=='2'">女</p>
              </div>
              <div class="item-box-li50 li33">
                <p class="name">年龄：</p>
                <p class="val">{{info.age}}</p>
              </div>
              <div class="item-box-li50 li33">
                <p class="name">种族：</p>
                <p class="val">{{info.nation}}</p>
              </div>
              <div class="item-box-li50 li33">
                <p class="name">籍贯：</p>
                <p class="val nowrap" :title="info.address">{{info.address}}</p>
              </div>
              <div class="item-box-li50 li33">
                <p class="name">电话：</p>
                <p class="val">{{info.phone}}</p>
              </div>
              <div class="item-box-li50 li33">
                <p class="name">健康状态:</p>
                <p class="val">{{info.health}}</p>
              </div>
              <div class="item-box-li50 li33">
                <p class="name">从业年限:</p>
                <p v-if="info.workYear" class="val">{{info.workYear}}年</p>
                <p v-else class="val">{{info.workYear}}</p>
              </div>
            </div>
            <div class="erCode">
                <vue-qr :text="codeUrl" :size="200"></vue-qr>
            </div>
          </div> -->
          <div class="headerA">
            个人档案
            <div class="bianji" @click="editFormVisible=true">编辑</div>
          </div>
          <div class="userinfoA" style="margin-bottom:10px">
            <div class="user-l">基础信息</div>
            <div class="user-m">
              <div class="user-box">
                <div class="row">
                  <div class="row-l">姓名：<span>{{ info.name }}</span></div>
                  <div class="row-m">性别：<span>{{ info.sex == 1 ? '男' : info.sex == 2 ? '女' : '' }}</span></div>
                  <div class="row-r">年龄：<span>{{ info.age }}</span></div>
                </div>
                <div class="row">
                  <div class="row-l">民族：<span>{{ info.nation }}</span></div>
                  <div class="row-m textA">籍贯：<span>{{ info.address }}</span></div>
                  <div class="row-r">电话：<span>{{ info.phone }}</span></div>
                </div>
                <div class="row">
                  <div class="row-l">学历：<span>{{
                      info.eduType == 1 ? '小学' :
                          info.eduType == 2 ? '初中' :
                              info.eduType == 3 ? '高中' :
                                  info.eduType == 4 ? '中专' :
                                      info.eduType == 5 ? '大专' :
                                          info.eduType == 6 ? '本科' :
                                              info.eduType == 7 ? '硕士' :
                                                  info.eduType == 8 ? '博士' :
                                                      info.eduType == 99 ? '其他' : ''
                    }}</span></div>
                  <div class="row-m">专业：<span>{{ info.specialty }}</span></div>
                  <div class="row-r" @click="zhengshu">证书：<span
                      :class="info.certificate?'blue1':''">{{ info.certificate ? '点击查看' : '暂无' }}</span></div>
                </div>
                <div class="row">
                  <div class="row-l">项目资格：<span>{{ info.jobPost }}</span></div>
                  <div class="row-m">从业年限：<span>{{ info.workYear ? info.workYear + '年' : '' }}</span></div>
                  <div class="row-r">健康状况：<span>{{ info.health }}</span></div>
                </div>
              </div>
            </div>
            <div class="user-r">
              <vue-qr :text="codeUrl" :size="160"></vue-qr>
            </div>
          </div>
          <!-- <div class="userinfo">
            <div class="userinfo-l">
              <div class="l-top">基 础 信 息</div>
              <div class="l-bottom">
                <div class="item">
                  <div class="item-t">姓名</div>
                  <div class="item-b">{{info.name}}</div>
                </div>
                <div class="item">
                  <div class="item-t">性别</div>
                  <div class="item-b">{{info.sex==1?'男':info.sex==2?'女':''}}</div>
                </div>
                <div class="item">
                  <div class="item-t">年龄</div>
                  <div class="item-b">{{info.age}}</div>
                </div>
                <div class="item">
                  <div class="item-t">民族</div>
                  <div class="item-b">{{info.nation}}</div>
                </div>
                <div class="item">
                  <div class="item-t">籍贯</div>
                  <div class="item-b">{{info.address}}</div>
                </div>
                <div class="item">
                  <div class="item-t">学历</div>
                  <div class="item-b">{{
                    info.eduType==1?'小学':
                    info.eduType==2?'初中':
                    info.eduType==3?'高中':
                    info.eduType==4?'中专':
                    info.eduType==5?'大专':
                    info.eduType==6?'本科':
                    info.eduType==7?'硕士':
                    info.eduType==8?'博士':
                    info.eduType==99?'其他':''}}</div>
                </div>
                <div class="item">
                  <div class="item-t">专业</div>
                  <div class="item-b">{{info.specialty}}</div>
                </div>

                <div class="item">
                  <div class="item-t">岗位资格</div>
                  <div class="item-b">{{info.jobPost}}</div>
                </div>
                <div class="item">
                  <div class="item-t">从业年限</div>
                  <div class="item-b">{{info.workYear?info.workYear+'年':''}}</div>
                </div>
                <div class="item">
                  <div class="item-t">健康状况</div>
                  <div class="item-b">{{info.health}}</div>
                </div>
                <div class="item item-z">
                  <div class="item-t">证书</div>
                  <div @click="zhengshu" :class="info.certificate?'item-b blue':'item-b'">{{info.certificate?'点击查看':'暂无'}}</div>
                </div>
              </div>
            </div>
            <div class="userinfo-r" style="height:195px;width:195px">
              <vue-qr :text="codeUrl" :size="180"></vue-qr>
            </div>
          </div> -->
          <!-- 在职情况 -->
          <div class="box2">
            <div class="box2-title">在 职 情 况</div>
            <div class="box2-cont">
              <div class="box2-cont-item cont-title">项目名称</div>
              <div class="box2-cont-item cont-title">班组</div>
              <div class="box2-cont-item cont-title">出勤</div>
              <div class="box2-cont-item cont-title">劳务工资</div>
              <div class="box2-cont-item cont-title">入职时间</div>
              <div class="box2-cont-item cont-title">离职时间</div>
            </div>
            <div class="box2-cont" v-for="(item,index) in obJob" :key="index">
              <div class="box2-cont-item cont-text">{{ item.projectName }}</div>
              <div class="box2-cont-item cont-text">{{ item.teamName }}</div>
              <div class="box2-cont-item cont-text">{{ item.days + ' 天' }}</div>
              <div class="box2-cont-item cont-text">{{ item.sumMonthSalary }}</div>
              <div class="box2-cont-item cont-text">{{ item.createDate }}</div>
              <div class="box2-cont-item cont-text">{{ item.updateDate ? item.updateDate : '' }}</div>
            </div>
            <div class="box2-cont" v-if="obJob.length===0">
              <div class="box2-cont-item cont-text"></div>
              <div class="box2-cont-item cont-text"></div>
              <div class="box2-cont-item cont-text"></div>
              <div class="box2-cont-item cont-text"></div>
              <div class="box2-cont-item cont-text"></div>
              <div class="box2-cont-item cont-text"></div>
            </div>
          </div>
          <!-- 工作记录 -->
          <div class="box2">
            <div class="box2-title">工 作 记 录</div>
            <div class="box2-cont">
              <div class="box2-cont-item cont-title">在职总出勤天数</div>
              <div class="box2-cont-item cont-title">在职总出勤时长</div>
              <div class="box2-cont-item cont-title">出勤率</div>
            </div>
            <div class="box2-cont">
              <div class="box2-cont-item cont-text">{{ days }}</div>
              <div class="box2-cont-item cont-text">{{ times }}</div>
              <div class="box2-cont-item cont-text"></div>
            </div>
          </div>
          <!-- 安全教育记录 -->
          <div class="box2">
            <div class="box2-title">安 全 教 育 记 录</div>
            <div class="box2-cont">
              <div class="box2-cont-item cont-title">试卷名称</div>
              <div class="box2-cont-item cont-title">测试得分</div>
              <div class="box2-cont-item cont-title">测试时长</div>
              <div class="box2-cont-item cont-title">是否通过</div>
            </div>
            <div class="box2-cont" v-for="(item,index) in educationLog" :key="index">
              <div class="box2-cont-item cont-text">{{ item.examName }}</div>
              <div class="box2-cont-item cont-text">{{ item.examScore }}</div>
              <div class="box2-cont-item cont-text">{{ item.testTime }}</div>
              <div class="box2-cont-item cont-text">{{ item.qualifiedFlag === "1" ? '通过' : '未通过' }}</div>
            </div>
            <div class="box2-cont" v-if="obJob.length===0">
              <div class="box2-cont-item cont-text"></div>
              <div class="box2-cont-item cont-text"></div>
              <div class="box2-cont-item cont-text"></div>
              <div class="box2-cont-item cont-text"></div>
            </div>
          </div>
          <!--  -->
          <div class="box2">
            <div class="box2-title">奖 惩 记 录</div>
            <div class="box2-cont">
              <div class="box2-cont-item cont-title">所属项目</div>
              <div class="box2-cont-item cont-title">事项</div>
              <div class="box2-cont-item cont-title">事项描述</div>
              <div class="box2-cont-item cont-title">时间</div>
            </div>
            <div class="box2-cont" v-for="(item,index) in rewards" :key="index">
              <div class="box2-cont-item cont-text">{{ item.projectName }}</div>
              <div class="box2-cont-item cont-text">{{ item.type == '1' ? '不良' : '奖励' }}</div>
              <div class="box2-cont-item cont-text"></div>
              <div class="box2-cont-item cont-text">{{ item.createDate }}</div>
            </div>
            <div class="box2-cont" v-if="rewards.length===0">
              <div class="box2-cont-item cont-text"></div>
              <div class="box2-cont-item cont-text"></div>
              <div class="box2-cont-item cont-text"></div>
              <div class="box2-cont-item cont-text"></div>
            </div>
          </div>
          <!--  -->
          <div class="box2">
            <div class="box2-title">工 作 经 历</div>
            <div class="box2-cont">
              <div class="box2-cont-item cont-title">公司名称</div>
              <div class="box2-cont-item cont-title">当前项目</div>
              <div class="box2-cont-item cont-title">班组</div>
              <div class="box2-cont-item cont-title">岗位</div>
              <div class="box2-cont-item cont-title">时间</div>
            </div>
            <div class="box2-cont" v-for="(item,index) in workloggers" :key="index">
              <div class="box2-cont-item cont-text">{{ item.entName }}</div>
              <div class="box2-cont-item cont-text">{{ item.projectName }}</div>
              <div class="box2-cont-item cont-text">{{ item.teamName }}</div>
              <div class="box2-cont-item cont-text">{{ item.work_type }}</div>
              <div class="box2-cont-item cont-text">
                {{ item.date + '~' + (item.endDate != null ? item.endDate : '至今') }}
              </div>
            </div>
            <div class="box2-cont" v-if="obJob.length===0">
              <div class="box2-cont-item cont-text"></div>
              <div class="box2-cont-item cont-text"></div>
              <div class="box2-cont-item cont-text"></div>
              <div class="box2-cont-item cont-text"></div>
              <div class="box2-cont-item cont-text"></div>
            </div>
          </div>
          <!-- 新增窗口 -->
          <el-dialog
              width="30%"
              title="个人信息编辑"
              :visible.sync="editFormVisible"
              center
              :append-to-body="true"
              :before-close="handleClose"
              :lock-scroll="false"
              class="add-form"
          >
            <el-form :model="addForm" ref="addForm" label-width="100px" :label-position="labelPosition">
              <el-form-item label="姓名：" prop="name">
                <el-input v-model="addForm.name" autocomplete="off" readonly style="width:250px"></el-input>
              </el-form-item>
              <el-form-item label="手机号码：" @input="change($even)">
                <el-input v-model="addForm.phone" autocomplete="off" style="width:250px"></el-input>
              </el-form-item>
              <el-form-item label="学历：">
                <el-select v-model="addForm.eduType" placeholder="请选择" style="width:250px">
                  <el-option v-for="item in eduTypes" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="专业：">
                <el-input v-model="addForm.specialty" autocomplete="off" placeholder="请输入专业"
                          style="width:250px"></el-input>
              </el-form-item>
              <el-form-item label="岗位资格：">
                <el-input v-model="addForm.jobPost" autocomplete="off" placeholder="请输入岗位资格"
                          style="width:250px"></el-input>
              </el-form-item>
              <el-form-item label="从业年限:">
                <el-input v-model="addForm.workYear" autocomplete="off" @input="change($even)"
                          placeholder="请输入从业年限(数字)" style="width:250px"></el-input>
              </el-form-item>
              <el-form-item label="健康状态:">
                <el-input v-model="addForm.health" autocomplete="off" @input="change($even)"
                          placeholder="请输入健康状况" style="width:250px"></el-input>
              </el-form-item>
              <el-form-item label="已上传证书：">
                <div
                    style="width:50px;height:50px;margin-top:5px;margin-right:5px;position: relative;"
                    v-for="(item, index ) in exitImgs"
                    :key="index"
                    @mouseenter="showDel(index)"
                    @mouseleave="hideDel"
                >
                  <img :src="item.src" style="width:50px;height:50px;"/>
                  <div
                      v-if="index==showDelFlag"
                      style="width:100%;height:100%;position: absolute;top:0;left:0;background:rgba(0, 0, 0, 0.3);display: flex;justify-content: center;align-items: center;"
                  >
                    <i
                        class="el-icon-delete"
                        style="color: #fff;font-size: 18px;cursor: pointer;"
                        @click="delExit(index)"
                    ></i>
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="证书：">
                <el-upload
                    class="avatar-uploader"
                    v-bind:action="uploadUrl"
                    :headers="uploadHead"
                    :data="{type:212}"
                    list-type="picture-card"
                    :on-success="handleIconSuccess"
                    :on-remove="handleRemove"
                    style="display: inline-block;height:50px;"
                >
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="editFormVisible = false">取 消</el-button>
              <el-button type="primary" @click="sumbitAddRow">确 定</el-button>
            </div>
          </el-dialog>
          <el-dialog
              top="5vh"
              :close-on-click-modal="false"
              :visible.sync="isShow"
              width="35%"
              :before-close="handleClose1">
            <img style="width:100%;height:750px" :src="'data:image/jpeg;base64,'+base64image0[imgIndex]" alt="">
            <span class="imgIndex">{{ imgIndex + 1 + '/' + base64image0.length }}</span>
            <div class="btn-l" @click="enterl"></div>
            <div class="btn-r" @click="enterr"></div>
            </el-image>
          </el-dialog>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import myHttp from '../../untils/port'
import util from '../../untils/util'
import base from '../../untils/base'
import vueQr from 'vue-qr'

export default {
  components: {
    vueQr
  },
  data() {
    return {
      info: {
        //人员信息
      },
      eduTypes: [
        //学历列表
        {id: '1', name: '小学'},
        {id: '2', name: '初中'},
        {id: '3', name: '高中'},
        {id: '4', name: '中专'},
        {id: '5', name: '大专'},
        {id: '6', name: '本科'},
        {id: '7', name: '硕士'},
        {id: '8', name: '博士'},
        {id: '99', name: '其他'}
      ],
      addForm: {
        //提交信息
        id: '',
        name: '',
        idcard: '', //身份证
        phone: '',
        specialty: '', //专业
        certificate: '', //证书
        eduType: '',//学历
        health: '',
        workYear: '',
        jobPost: '',//岗位资格
      },
      id: '',
      groupId: util.session.get('groupId'),
      groupInfo: {},
      listData: [], //技能测试列表
      editFormVisible: false, //弹出框标识
      labelPosition: 'right',
      headPic: '', //上传头像展示
      uploadUrl: base.url + '/upload/uploadPhoto', //上传地址
      uploadHead: {
        //上传接口header参数
        accessToken: this.$store.state.token
      },
      obJob: [], //在职情况
      dialogVisible: false, //隐藏
      fileList: [], //新增证书
      exitImgs: [], //已有证书(编辑)
      exitImgsPage: [], //页面展示已有证书
      exitImgsPageList: [],//页面展示已有证书-展示
      showDelFlag: -1, //展示删除图片
      isPro: false, //是否是项目端打开页面
      badData: [],//奖惩列表
      codeUrl: '',
      days: 0,// 出勤天数
      times: 0,//出勤时长
      educationLog: [], // 安全教育记录
      rewards: [], // 奖惩记录
      workloggers: [],//工作经历
      isShow: false,
      base64image0: '',
      imgIndex: 0,
      treeId: '',
      type: ''
    }
  },
  mounted() {
    let params = this.$route.params
    this.id = params.id
    this.treeId = params.treeId
    this.type = params.type

    var port = util.session.get('roleId')
    if (port == '4') {
      this.isPro = true
    }
    // this.groupId = params.groupId
    this.getData()
    //this.getMonthList();
    this.getReward()
  },
  methods: {
    a() {
      // console.log(this.info)
    },
    // 获取数据
    getData() {
      var that = this
      myHttp
          .getPersonByProject2({
            prosonId: this.id,
            projectId: this.groupId
          })
          .then(
              function (resp) {
                console.log(resp, '999999999999999999')
                if (resp.data.code == '200') {
                  // console.log(resp)
                  that.info = resp.data.data.baseInfo
                  that.info.age =
                      that.info.birthday && that.info.birthday != ''
                          ? parseInt(new Date().getFullYear()) -
                          parseInt(that.info.birthday.split('-')[0])
                          : ''
                  that.obJob = resp.data.data.workLogger
                  that.obJob.forEach((item, index) => {
                    // console.log(item.createDate)
                    let date = new Date(parseInt(item.createDate))
                    let Y = date.getFullYear() + '-';
                    let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                    let D = date.getDate() + ' ';
                    let h = date.getHours() + ':';
                    let m = date.getMinutes() + ':';
                    let s = date.getSeconds();
                    item.createDate = Y + M + D
                    if (item.updateDate) {
                      item.updateDate = util.myTime.timeaaa(item.updateDate)
                    }
                    that.days += item.days
                    that.times += item.workHours
                  })
                  that.educationLog = resp.data.data.educationLog
                  that.rewards = resp.data.data.rewards
                  that.workloggers = resp.data.data.workloggers
                  that.workloggers.forEach((item, index) => {
                    myHttp.getDict({
                      value: item.work_type
                    }).then(res => {
                      // console.log(res,'999999999999')
                      item.work_type = res.data.data.label
                    })
                  })

                  that.addForm.id = that.info.id
                  that.addForm.name = that.info.name
                  that.addForm.idcard = that.info.idcard
                  that.addForm.phone = that.info.phone
                  that.addForm.specialty = that.info.specialty
                  that.addForm.certificate = that.info.certificate
                  that.addForm.eduType = that.info.eduType
                  that.addForm.health = that.info.health
                  that.addForm.workYear = that.info.workYear
                  var imgs =
                      that.info.certificate && that.info.certificate != ''
                          ? that.info.certificate.split(',')
                          : []
                  that.exitImgsPageList = []
                  for (var i = 0; i < imgs.length; i++) {
                    var obj = {src: '', url: ''}
                    obj.src = base.httpCtx + imgs[i]
                    obj.url = imgs[i]
                    that.exitImgs.push(obj)
                    that.exitImgsPage.push(obj)
                    that.exitImgsPageList.push(obj.src)
                  }
                  // 二维码
                  var obj = {
                    type: 3,
                    personId: that.id,
                    personName: that.info.name,
                    projectId: that.groupId,
                    show: 0,
                    path: '/pages/personFile/personFile?id=' + that.id + '&show=0'
                  }
                  // this.codeUrl = '/pages/personFile/personFile?id='+this.id+'&show=0'
                  that.codeUrl = JSON.stringify(obj)
                } else {
                  that.$message.error(resp.data.msg)
                }
              },
              function () {
              }
          )
      // myHttp.findAllAttendByPersonId({
      //     personId: this.id,
      //     projectId: this.groupId
      //   })
      //   .then(
      //     function(resp) {
      //       if (resp.data.code == '200') {
      //         var data = resp.data.data
      //         that.info.name = data.name
      //         that.info.idcard = data.idcard
      //         that.info.attendDay = data.attendDay
      //         that.info.attendTime = data.attendTime
      //         that.info.photoUrl = base.httpCtx + data.photoUrl
      //         that.info.idcardUrl = base.httpCtx + data.idcardUrl
      //       } else {
      //         that.$message.error(resp.data.msg)
      //       }
      //     },
      //     function() {}
      //   )
    },

    //获取奖惩列表
    getReward() {
      var that = this
      myHttp.secBadRecordByAreaId({
        personId: this.id
      }).then(function (resp) {
        console.log(resp)
        if (resp.data.code == 200) {
          var list = resp.data.data.list || []
          // if(list.length==0){
          //   var obj = {
          //     type:'2',
          //     id:'1',
          //     projectName:'测试项目111',
          //     recordTypeName:'安全教育',
          //     desc:'在系统中完成安全教育视频的观看。',
          //     createDate:'2020-10-08'
          //   }
          //   list.push(obj)
          //   var obj1 = {
          //     type:'1',
          //     id:'2',
          //     projectName:'测试项目111',
          //     recordTypeName:'未戴安全帽',
          //     desc:'在施工现场，没有按照规定戴安全帽进行施工',
          //     createDate:'2020-10-12'
          //   }*.
          //   list.push(obj1)
          // }
          that.badData = list
        }
      })
    },

    //监听月份修改
    monthChange(val) {
      this.getMonthData()
    },
    //返回
    goBack() {
      if (this.type == 2) {
        this.$router.push({
          path: '/workerPool2',
          query: {
            treeId: this.treeId
          }
        })
      } else {
        this.$router.go(-1)
      }
    },
    /**
     * 保存数据
     */
    sumbitAddRow() {
      let that = this
      var img = ''
      this.addForm.certificate = ''
      //拼接已有和新加
      for (var i = 0; i < this.exitImgs.length; i++) {
        if (this.addForm.certificate == '') {
          this.addForm.certificate = this.exitImgs[i].url
        } else {
          this.addForm.certificate += ',' + this.exitImgs[i].url
        }
      }
      for (var i = 0; i < this.fileList.length; i++) {
        if (this.addForm.certificate == '') {
          this.addForm.certificate = this.fileList[i].url
        } else {
          this.addForm.certificate += ',' + this.fileList[i].url
        }
      }
      myHttp.modProjectPerson({
        projectId: this.groupId,
        ...this.addForm
      }).then(
          function (resp) {
            if (resp.data.code == 200) {
              that.$message.success('操作成功')
              that.editFormVisible = false
              that.$router.go(0)
            } else {
              that.$message.error(resp.data.msg)
            }
          },
          function (error) {
            that.$message.error('服务器繁忙，请稍后再试')
          }
      )
    },
    /**
     * 删除证书
     */
    handleRemove(file, fileList) {
      var list = this.fileList
      var result = []
      for (var i = 0; i < list.length; i++) {
        if (file.uid != list[i].uid) {
          result.push(list[i])
        }
      }
      this.fileList = result
    },
    //上传证书成功事件
    handleIconSuccess(res, file) {
      if (res.code == '200') {
        // this.headPic = URL.createObjectURL(file.raw);
        // this.addForm.headImgUrl = res.data.saveUrls;
        var obj = {uid: file.uid, url: res.data.saveUrls}
        this.fileList.push(obj)
      } else {
        this.$message.error(res.msg)
      }
    },
    // 关闭弹出框弹窗
    handleClose(done) {
      this.editFormVisible = false
      this.fileList = []
    },
    handleClose1(done) {
      this.isShow = false
    },
    //展示已存在的证书删除按钮
    showDel(index) {
      console.log(index)
      this.showDelFlag = index
    },
    hideDel() {
      this.showDelFlag = -1
    },

    //删除已存在的证书
    delExit(index) {
      this.exitImgs.splice(index, 1)
    },
    change(e) {
      this.$forceUpdate()
    },
    zhengshu() {
      if (this.info.certificate) {
        let that = this
        myHttp.getPersonByCertificate({
          type: '212',
          fileName: that.info.certificate
        }).then(res => {
          console.log(res.data.data.data, 'zhaopian')
          that.base64image0 = res.data.data.data
          console.log(that.base64image0, 'zhaopian1')
          that.isShow = true
        })
      }
    },
    enterl() {
      if (this.imgIndex !== 0) {
        --this.imgIndex
      }
    },
    enterr() {
      if (this.imgIndex !== this.base64image0.length - 1) {
        this.imgIndex++
      }
    }
    // guifan() {
    //   this.$router.push({ name: 'guifan' })
    // },

    //导出
    // exportOut() {
    //   {
    //     console.log(this.id)
    //     var token = this.$store.state.token
    //     window.open(
    //       myHttp.exportBackPerson +
    //         '?id=' +
    //         this.id +
    //         '&groupId=' +
    //         this.groupId +
    //         '&groupType=1&accessToken=' +
    //         token
    //     )
    //   }
    // }
  }
}
</script>
<style>
@import '../../assets/css/common.css';
</style>
<style scoped>
::v-deep .aside {
  background-color: #f2f2f2 !important;
}

.content {
  background-color: #f2f2f2;
}

.exit-btn {
  display: flex;
  justify-content: center;
  align-items: center;
}

.userinfo {
  height: 180px;
  /* background-color: #E7E7E7; */
  display: flex;
  justify-content: space-between;
  margin-bottom: 45px;
}

.userinfo-l {
  flex: 1;
  height: 180px;
  margin-right: 5px;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0px 3px 7px 0px rgba(105, 159, 204, 0.35)

}

.l-top {
  height: 60px;
  line-height: 60px;
  background-color: #e6e6e6;
  font-family: PingFang-SC-Bold;
  font-size: 24px;
  font-weight: normal;
  font-stretch: normal;
  color: #333333;
}

.l-bottom {
  display: flex;
  width: 100%;
  height: 120px;
}

.item {
  flex: 1;
  background-color: #E7E7E7;
  margin-right: 2px;
}

.item-z {
  margin-right: 0;
}

.item-t {
  height: 60px;
  line-height: 60px;
  text-align: center;
  margin-bottom: 2px;
  background-color: #fff;
  font-family: PingFang-SC-Medium;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  color: #333333;
  letter-spacing: 0px;
}

.item-b {
  height: 60px;
  line-height: 60px;
  text-align: center;
  font-family: PingFang-SC-Medium;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  color: #666666;
  background-color: #fff;
  letter-spacing: 0px;
}

.userinfo-r {
  border-radius: 12px;
  overflow: hidden;
}

.box {
  width: 100%;
  height: 180px;
  display: flex;
  border-radius: 10px;
  margin-bottom: 45px;

}

.box-l {
  flex: 1;
  margin-right: 0.2vw;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0px 3px 7px 0px rgba(105, 159, 204, 0.35);
}

.box-l-title, .box-r-title {
  background-color: #e6e6e6;
  height: 60px;
  text-align: center;
  line-height: 60px;
  font-family: PingFang-SC-Bold;
  font-size: 24px;
  font-weight: normal;
  font-stretch: normal;
  color: #333333;
}

.box-l-content {
  height: 120px;
  overflow-y: scroll;

}

.box-l-content::-webkit-scrollbar {
  width: 0 !important
}

.box-l-content > div {
  height: 60px;
  background-color: #fff;
  margin-bottom: 0.2vh;
  font-family: PingFang-SC-Medium;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #666666;
}

.box-l-content > div:last-child {
  margin-bottom: 0px;
}

.box-r {
  flex: 1;
  border-radius: 10px 10px 10px 10px;
  overflow: hidden;
  box-shadow: 0px 3px 7px 0px rgba(105, 159, 204, 0.35);
}

.box-r-content {
  width: 100%;
  display: flex;
}

.box-r-content-l {
  margin-right: 0.1vw;
}

.box-r-content-l, .box-r-content-r {
  height: 60px;
  flex: 1;
}

.l-up, .l-down, .r-up, .r-down {
  background-color: #fff;
  height: 60px;
  line-height: 60px;
}

.l-up, .r-up {
  margin-bottom: 0.2vh;
  font-family: PingFang-SC-Medium;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  color: #333333;
  letter-spacing: 0px;
}

/* 安全教育记录 奖惩记录 */
.box1 {
  width: 100%;
  height: 180px;
  display: flex;
  border-radius: 10px;
  margin-bottom: 45px;
}

.box1-l, .box1-r {
  flex: 1;
  box-shadow: 0px 3px 7px 0px rgba(105, 159, 204, 0.35);
}

.box1-l-title, .box1-r-title {
  background-color: #e6e6e6;
  height: 60px;
  text-align: center;
  line-height: 60px;
  font-family: PingFang-SC-Bold;
  font-size: 24px;
  font-weight: normal;
  font-stretch: normal;
  color: #333333;
}

.box1-l {
  margin-right: 0.2vw;
  overflow: hidden;
  border-radius: 10px;

}

.box1-r {
  overflow: hidden;
  border-radius: 10px;
}

.box1-l .box1-l-cont {
  display: flex;
  margin-bottom: 0.2vh;
}

.scroll {
  height: 120px;
  overflow-y: scroll
}

.scroll::-webkit-scrollbar {
  width: 0 !important
}

.box1-l .box1-l-cont:last-child {
  margin-bottom: 0;
}

.cont-item {
  flex: 1;
  height: 60px;
  line-height: 60px;
  margin-right: 0.1vw;
  background-color: #fff;
  font-family: PingFang-SC-Medium;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #333333;
}

.cont-text {
  font-family: PingFang-SC-Medium;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #666666;
}

.box1-l-cont > .cont-item:last-child {
  margin-right: 0;
}

.box1-r .box1-r-cont {
  display: flex;
  margin-bottom: 0.2vh;
}

.box1-r .box1-r-cont:last-child {
  margin-bottom: 0;
}

.box1-r-cont > .cont-item:last-child {
  margin-right: 0;
}

/* -------------- */
.box2 {
  width: 100%;
  margin-bottom: 10px;
  box-shadow: 0px 3px 7px 0px rgba(105, 159, 204, 0.35);
  border-radius: 6px;
  overflow: hidden;

}

.box2-title {
  height: 5vh;
  background: #EBEBEB;
  text-align: center;
  line-height: 5vh;
  font-family: SourceHanSansCN-Regular;
  font-size: 20px;
  font-weight: normal;
  letter-spacing: 0em;
  color: #909399;
}

.cont-title {
  font-family: PingFang-SC-Medium;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #333333;
}

.box2-cont {
  display: flex;
  margin-bottom: 0.2vh;
}

.box2-cont:last-child {
  margin-bottom: 0;
}

.box2-cont-item {
  flex: 1;
  height: 60px;
  line-height: 60px;
  margin-right: 0.1vw;
  background-color: #fff;
}

/* --------------- */
.content >>> .el-card__body {
  padding: 0 !important;
  height: 100% !important;
  overflow: auto;
  background-color: none;
  border-radius: 10px;
}

.grid-content {
  height: 2.5vh;
  font-size: 1.6vh;
}

.aside {
  box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
  border-radius: 10px !important;
  border: 0px !important;
  background-color: #E7E7E7;
  display: flex;
  flex-direction: column;
}

.search-section {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 20px 35px 20px -12px;
  height: 40px;
  justify-content: space-between;
}

/*  */
.build-CURD {
  width: 100%;
  height: 100%;
  position: relative;
}

.build-table {
  width: 100%;
  height: calc(100% - 66px);
  display: flex;
  position: relative;
  align-content: flex-start;
}

.build-bar {
  width: 100%;
  height: 200px;
  padding: 10px 30px;
  flex-wrap: wrap;
}

.el-table >>> .cell {
  overflow: hidden;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
}

.build-bar >>> .btnLef {
  margin-left: 200px;
}

.el-form >>> .upload-demo {
  width: 220px;
  margin-bottom: 20px;
  margin-left: 100px;
}

.add-form >>> .el-upload-dragger {
  width: 100%;
  height: 100px;
}

.add-user {
  position: absolute;
  top: 8px;
  right: 50px;
}

.build-bar .add-user >>> span {
  text-align: center;
  margin-left: 2px;
}

.add-form .el-form-item {
  width: 80%;

}

.el-dropdown-link {
  cursor: pointer;
  color: #666;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.role-tree {
  overflow-y: scroll;
  min-height: 200px;
}

.build-bar .el-button {
  background-color: #17b2fe;
  border-color: #17b2fe;
  margin-left: 30px;
}

.build-title {
  height: 60px;
  box-shadow: 0 0 0 0 #ddd;
  border-bottom: 5px solid #ecf0f5;
  display: flex;
  align-items: center;
  align-content: center;
  padding: 0 20px;
}

.build-title img {
  cursor: pointer;
}

.table-item {
  width: 100%;
  min-height: 50px;
  display: flex;
  /* margin-bottom: 20px; */
  border-bottom: 15px solid #ecf0f5;
}

.item-name {
  width: 240px;
  height: 100%;
  background: #0085ff;
  color: #fff;
  display: flex;
  justify-content: center;
  justify-items: center;
  align-content: center;
  align-items: center;
  font-size: 24px;
}

.item-box {
  position: relative;
  width: calc(100% - 240px);
  display: flex;
  flex-wrap: wrap;
  border-bottom: 1px solid #ddd;
}

.item-box-li50 {
  width: 50%;
  position: relative;
  /* height: 40px; */
  display: flex;
  align-content: center;
  align-items: center;
}

.li33 {
  width: 33%;
}

.item-box-li50 .name {
  width: 160px;
  margin: 0;
  text-align: right;
  font-size: 16px;
  color: #000;
  font-weight: 400;
}

.item-box-li50 .val {
  flex: 1;
  margin: 0;
  text-align: left;
  font-size: 16px;
  color: #000;
  font-weight: 400;
}

.item-right {
  width: 200px;
  height: 200px;
  display: flex;
  justify-content: center;
  justify-items: center;
  align-content: center;
  align-items: center;
  flex-wrap: wrap;
  border-bottom: 1px solid #ddd;
}

.flex-wrap {
  display: flex;
  flex-wrap: wrap;
}

.h200 {
  height: 200px;
}

.h150 {
  height: 150px;
}

.h150 .item-box {
  align-content: center;
  align-items: center;
}

.item-box-li50 .font-color1 {
  color: #85ce61;
}

.item-box-li50 .font-color2 {
  color: red;
}

.table-item-head {
  width: 100%;
  height: 50px;
  position: relative;
  display: flex;
  justify-content: center;
  justify-items: center;
  align-content: center;
  align-items: center;
  background: #4d7bf4;
  color: #fff;
}

.table-item-table {
  width: 100%;
  height: auto;
  position: relative;
}

.table-item-li {
  width: 100%;
  height: auto;
  position: relative;
  display: flex;
  flex-wrap: wrap;
}

.li-item {
  width: 16%;
  height: 50px;
  position: relative;
  display: flex;
  align-content: center;
  align-items: center;
}

.li-item.center {
  justify-content: center;
  justify-items: center;
}

.li-item.right {
  justify-content: flex-end;
  justify-items: flex-end;
}

/*不换行（span）*/
.nowrap {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.add-form .el-select .el-input {
  width: 100%;
}

.el-upload {
  width: 50px;
  height: 50px;
  line-height: 60px;
}

.el-upload-list--picture-card .el-upload-list__item {
  width: 50px;
  height: 50px;
}

.el-form-item__content {
  display: flex;
}

div >>> .el-upload--picture-card {
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  box-sizing: border-box;
  width: 80px;
  height: 80px;
  line-height: 80px;
  vertical-align: top;
}

.bad-color1 {
  color: #F56C6C;
}

.bad-color2 {
  color: #67C23A;
}

.erCode {
  width: 200px;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  justify-items: center;
  align-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.blue1 {
  font-family: PingFang-SC-Medium;
  text-decoration: underline;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #0b62f0 !important;
  cursor: pointer;
}

.el-dialog__body {
  position: relative;
  padding-bottom: 0;
}

.el-dialog__body > .btn-l {
  position: absolute;
  left: -76px;
  top: 342px;
  width: 0px;
  height: 0px;
  border: 25px solid #000;
  border-top-color: transparent;
  border-bottom-color: transparent;
  border-left-color: transparent;
  border-right-color: red;
  opacity: 0.6;
}

.el-dialog__body > .btn-r {
  position: absolute;
  right: -76px;
  top: 342px;
  width: 0px;
  height: 0px;
  border: 25px solid #000;
  border-top-color: transparent;
  border-bottom-color: transparent;
  border-left-color: red;
  border-right-color: transparent;
  opacity: 0.6;
}

.imgIndex {
  font-size: 24px;
}

.headerA {
  position: relative;
  border-radius: 6px 6px 0px 0px;
  background: #EBEBEB;
  box-shadow: 0px 2px 10px 0px rgba(140, 168, 225, 0.5);
  font-family: SourceHanSansCN-Regular;
  font-size: 20px;
  font-weight: normal;
  letter-spacing: 0em;
  color: #909399;
  height: 5.1vh;
  line-height: 5.1vh;
  margin-bottom: 10px;
}

.bianji {
  position: absolute;
  right: 0.8%;
  width: 80px;
  height: 32px;
  border-radius: 6px;
  background: #FDFEFE;
  box-sizing: border-box;
  border: 1px solid rgba(153, 153, 153, 0.8);
  font-family: SourceHanSansCN-Regular;
  font-size: 14px;
  font-weight: normal;
  letter-spacing: 0em;
  color: #666666;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 18%;
}

.bianji:hover {
  opacity: 0.7;
  cursor: pointer;
}

.userinfoA {
  height: 17vh;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
}

.user-l {
  background-color: #EBEBEB;
  width: 11vw;
  display: flex;
  justify-content: center;
  align-items: center;
}

.user-r {
  width: 11vw;
  display: flex;
  justify-content: center;
  align-items: center;
}

.user-m {
  flex: 1;


}

.user-box {
  flex: 1;
  display: flex;
  justify-content: space-between;
  padding: 1vh 2vh;

}

.row-l, .row-m, .row-r {
  margin-top: 2vh;
  display: flex;
  justify-content: start;
  font-family: SourceHanSansCN-Regular;
  font-size: 18px;
  font-weight: normal;
  letter-spacing: 0em;
  color: #909399;
}

.row-l > span, .row-m > span, .row-r > span {
  color: #333333;
}

.textA {
  display: block;
  width: 13vw;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.cont-title {

  font-family: SourceHanSansCN-Regular;
  font-size: 18px;
  font-weight: normal;
  letter-spacing: 0em;
  color: #909399;
}

.cont-text {
  font-family: SourceHanSansCN-Regular;
  font-size: 18px;
  font-weight: normal;
  letter-spacing: 0em;
  color: #666666;
}
</style>
